import {ReactNode} from 'react';

import {Tooltip, Badge} from '@sail/ui';
import {useIntl} from 'react-intl';
import {noTranslateMessages} from '../helpers/noTranslate';

const devMessages = noTranslateMessages({
  badgeLabel: {
    id: 'conversations_ui.header.dev_badge_label',
    defaultMessage: 'Dev',
  },
  syntheticsModeLabel: {
    id: 'support_conversations_client.header.dev_badge.synthetics_mode_label',
    defaultMessage: 'Synthetics',
  },
});

function showDevBadge({
  url,
  dev = false,
  forestVersion,
  testAgentMode,
}: {
  url: URL;
  dev: boolean;
  forestVersion: string;
  testAgentMode: string;
}) {
  const host = url.host.toLowerCase();
  if (
    host.endsWith('-mydev.dev.stripe.me') ||
    host.startsWith('qa-support') ||
    forestVersion !== 'off' ||
    testAgentMode !== 'off' ||
    dev
  ) {
    return true;
  }

  return false;
}

function SyntheticBadge() {
  const intl = useIntl();

  return (
    <Badge type="info" data-testid="dev-badge">
      {intl.formatMessage(devMessages.syntheticsModeLabel)}
    </Badge>
  );
}

export function DevBadge({
  dev = false,
  synthetic = false,
  children,
}: {
  dev: boolean;
  synthetic: boolean;
  children?: ReactNode;
}) {
  const intl = useIntl();
  const url = new URL(window.location.href);
  const urlSearchParams = new URLSearchParams(window.location.search);
  const forestVersion = urlSearchParams.get('forestVersion') || 'off';
  const testAgentMode = urlSearchParams.get('test_agent_mode') || 'off';

  if (synthetic) {
    return <SyntheticBadge />;
  }

  if (!showDevBadge({url, dev, forestVersion, testAgentMode})) {
    return null;
  }

  return (
    <Tooltip
      trigger={
        <Badge type="info" data-testid="dev-badge">
          {intl.formatMessage(devMessages.badgeLabel)}
        </Badge>
      }
    >
      {children}
    </Tooltip>
  );
}
